import type { FilterOption } from "./filter-select";

interface FilterSelectSelection {
  option: FilterOption | null;
  label: string | null;
}

export function filterSelectSelection(
  options: FilterOption[],
  value: string | null,
): FilterSelectSelection {
  const option = options.find((candidate) => candidate.value === value) ?? null;
  return { option, label: option?.label ?? value };
}
